var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScreamboto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12,
    clipPath: "url(#clip0_588_2927)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_588_2927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7051 21.4117C28.7051 11.6655 36.6059 3.76465 46.3521 3.76465C56.0983 3.76465 63.9992 11.6655 63.9992 21.4117V36.7058H28.7051V21.4117Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.7051 21.4117C28.7051 11.6655 36.6059 3.76465 46.3521 3.76465C56.0983 3.76465 63.9992 11.6655 63.9992 21.4117V36.7058H28.7051V21.4117Z",
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.6458,
    cy: 15.4535,
    rx: 2.82353,
    ry: 3.18786,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_588_2927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.4121 21.4118C89.4121 11.6656 97.313 3.76477 107.059 3.76477C116.805 3.76477 124.706 11.6656 124.706 21.4118V36.7059H89.4121V21.4118Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.4121 21.4118C89.4121 11.6656 97.313 3.76477 107.059 3.76477C116.805 3.76477 124.706 11.6656 124.706 21.4118V36.7059H89.4121V21.4118Z",
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.353,
    cy: 15.4536,
    rx: 2.82353,
    ry: 3.18786,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_588_2927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.76562 38.5882C3.76562 32.3506 8.82217 27.2941 15.0597 27.2941H105.413C111.65 27.2941 116.707 32.3506 116.707 38.5882V128.941C116.707 135.179 111.65 140.235 105.413 140.235H15.0597C8.82218 140.235 3.76562 135.179 3.76562 128.941V38.5882Z",
    fill: "#ACACAC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.76562 38.5882C3.76562 32.3506 8.82217 27.2941 15.0597 27.2941H105.413C111.65 27.2941 116.707 32.3506 116.707 38.5882V128.941C116.707 135.179 111.65 140.235 105.413 140.235H15.0597C8.82218 140.235 3.76562 135.179 3.76562 128.941V38.5882Z",
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_588_2927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8242 38.5882C50.8242 32.3506 55.8808 27.2941 62.1183 27.2941H144.942C151.179 27.2941 156.236 32.3506 156.236 38.5882V128.941C156.236 135.179 151.179 140.235 144.942 140.235H62.1183C55.8808 140.235 50.8242 135.179 50.8242 128.941V38.5882Z",
    fill: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.8242 38.5882C50.8242 32.3506 55.8808 27.2941 62.1183 27.2941H144.942C151.179 27.2941 156.236 32.3506 156.236 38.5882V128.941C156.236 135.179 151.179 140.235 144.942 140.235H62.1183C55.8808 140.235 50.8242 135.179 50.8242 128.941V38.5882Z",
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.236 64.3473V128.941C156.236 135.179 151.18 140.235 144.942 140.235H15.0597C8.82216 140.235 3.76562 135.179 3.76562 128.941V92.7461C24.3122 70.9992 61.5161 56.4706 104.001 56.4706C122.77 56.4706 140.509 59.3063 156.236 64.3473Z",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1186 66.2833V128.941C46.1186 135.179 41.062 140.235 34.8244 140.235H15.0597C8.82218 140.235 3.76562 135.179 3.76562 128.941V92.7462C14.1309 81.7753 28.7354 72.6415 46.1186 66.2833Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.058 29.1764H128.94L102.587 138.353H84.7051L111.058 29.1764Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.999 29.1764H106.823L80.47 138.353H77.6465L103.999 29.1764Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2256 69.584C86.9632 81.5934 75.5045 84.8665 66.9423 79.6887C58.38 74.5109 55.9565 62.843 63.2188 50.8336C70.4812 38.8241 84.6794 31.0209 93.2416 36.1987C101.804 41.3765 101.488 57.5746 94.2256 69.584Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.116 69.584C120.379 81.5934 131.837 84.8665 140.4 79.6887C148.962 74.5109 151.385 62.843 144.123 50.8336C136.861 38.8241 122.662 31.0209 114.1 36.1987C105.538 41.3765 105.854 57.5746 113.116 69.584Z",
    fill: "white",
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.766 107.201C123.766 122.925 114.811 132.706 103.766 132.706C92.7199 132.706 83.7656 122.925 83.7656 107.201C83.7656 91.4771 92.7199 75.7646 103.766 75.7646C114.811 75.7646 123.766 91.4771 123.766 107.201Z",
    fill: "#4C4C4C",
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9228 131.736C106.118 128.905 112.08 120.031 112.08 107.201C112.08 94.3707 106.118 81.5481 97.9228 77.2632C89.7275 81.5481 83.7656 94.3707 83.7656 107.201C83.7656 120.031 89.7275 128.905 97.9228 131.736Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9228 131.736L97.3081 133.515L97.9228 133.728L98.5375 133.515L97.9228 131.736ZM97.9228 77.2632L98.795 75.5951L97.9228 75.1391L97.0506 75.5951L97.9228 77.2632ZM110.198 107.201C110.198 119.479 104.533 127.461 97.3081 129.957L98.5375 133.515C107.703 130.349 113.962 120.584 113.962 107.201H110.198ZM97.0506 78.9313C100.66 80.8184 103.961 84.7052 106.371 89.829C108.768 94.9234 110.198 101.063 110.198 107.201H113.962C113.962 100.509 112.411 93.8219 109.778 88.2262C107.159 82.6598 103.381 77.9928 98.795 75.5951L97.0506 78.9313ZM85.648 107.201C85.648 101.063 87.0773 94.9234 89.4742 89.829C91.885 84.7052 95.1856 80.8184 98.795 78.9313L97.0506 75.5951C92.4647 77.9928 88.6868 82.6598 86.0677 88.2262C83.4349 93.8219 81.8833 100.509 81.8833 107.201H85.648ZM98.5375 129.957C91.3129 127.461 85.648 119.479 85.648 107.201H81.8833C81.8833 120.584 88.1422 130.349 97.3081 133.515L98.5375 129.957Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6797 115.457C88.1201 113.566 92.2 112.471 96.5748 112.471C106.536 112.471 114.968 118.148 117.803 125.976C114.193 130.307 109.236 132.706 103.766 132.706C94.8085 132.706 87.2267 126.274 84.6797 115.457Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6797 115.457L83.7728 113.808L82.5197 114.497L82.8474 115.889L84.6797 115.457ZM117.803 125.976L119.249 127.181L119.941 126.351L119.573 125.335L117.803 125.976ZM85.5866 117.107C88.7464 115.369 92.514 114.353 96.5748 114.353V110.588C91.886 110.588 87.4937 111.762 83.7728 113.808L85.5866 117.107ZM96.5748 114.353C105.862 114.353 113.507 119.64 116.034 126.617L119.573 125.335C116.43 116.657 107.21 110.588 96.5748 110.588V114.353ZM116.358 124.771C113.086 128.695 108.649 130.824 103.766 130.824V134.588C109.822 134.588 115.299 131.92 119.249 127.181L116.358 124.771ZM103.766 130.824C95.8559 130.824 88.9016 125.174 86.5119 115.026L82.8474 115.889C85.5518 127.374 93.7612 134.588 103.766 134.588V130.824Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76562 38.7488C3.76562 32.5113 8.82217 27.4547 15.0597 27.4547H144.942C151.18 27.4547 156.236 32.5113 156.236 38.7488V129.766C156.236 136.004 151.18 141.06 144.942 141.06H15.0597C8.82216 141.06 3.76562 136.004 3.76562 129.766V38.7488Z",
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8242 51.4547C50.8242 38.1999 61.5694 27.4547 74.8242 27.4547H132.236C145.491 27.4547 156.236 38.1999 156.236 51.4547V117.06C156.236 130.315 145.491 141.06 132.236 141.06H74.8242C61.5694 141.06 50.8242 130.315 50.8242 117.06V51.4547Z",
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5291,
    cy: 90.3529,
    r: 16.9412,
    fill: "#222222",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_588_2927)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.0584,
    cy: 85.1765,
    r: 16.9412,
    fill: "#949494"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 23.0584,
    cy: 85.1765,
    r: 16.9412,
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7637 73.8823C29.4768 74.7942 30.9413 76.2702 31.999 78.1176",
    stroke: "white",
    strokeWidth: 3.76471,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_588_2927)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.6457,
    cy: 85.1764,
    r: 11.2941,
    fill: "#E2E2E2"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 13.6457,
    cy: 85.1764,
    r: 11.2941,
    stroke: "#212121",
    strokeWidth: 3.76471
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.659 106.024C149.732 104.933 148.869 104 147.775 104H131.738C130.782 104 129.977 104.724 129.868 105.674C127.243 128.642 126.104 141.456 128.38 162.096C128.485 163.045 129.29 163.765 130.245 163.765H150.586C151.74 163.765 152.622 162.734 152.448 161.593C149.745 143.817 148.109 129.115 149.659 106.024Z",
    fill: "#ACACAC",
    stroke: "#212121",
    strokeWidth: 3.76471,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.354 106.024C157.43 104.933 156.567 104 155.474 104H139.123C138.166 104 137.36 104.724 137.254 105.675C134.701 128.642 134.912 141.456 137.252 162.096C137.359 163.045 138.164 163.765 139.119 163.765H156.864C158.018 163.765 158.899 162.734 158.732 161.593C156.133 143.817 155.74 129.115 157.354 106.024Z",
    fill: "#C6C6C6",
    stroke: "#212121",
    strokeWidth: 3.76471,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8006 106.04C55.7187 104.943 56.5835 104 57.6837 104H75.9564C76.9037 104 77.7044 104.711 77.8239 105.65C80.7486 128.642 82.0186 141.459 79.4798 162.12C79.3644 163.059 78.564 163.765 77.6182 163.765H54.5578C53.3907 163.765 52.5055 162.712 52.7002 161.561C55.7056 143.804 57.5223 129.108 55.8006 106.04Z",
    fill: "#C6C6C6",
    stroke: "#212121",
    strokeWidth: 3.76471,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2318 106.039C47.1502 104.942 48.0149 104 49.115 104H67.7371C68.6847 104 69.4859 104.711 69.6023 105.652C72.4489 128.643 72.2135 141.459 69.6053 162.12C69.4868 163.058 68.6867 163.765 67.7406 163.765H45.9981C44.8314 163.765 43.9463 162.713 44.1404 161.562C47.1371 143.804 48.9486 129.108 47.2318 106.039Z",
    fill: "#ACACAC",
    stroke: "#212121",
    strokeWidth: 3.76471,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_588_2927",
    x: 26.8223,
    y: 1.88232,
    width: 39.0586,
    height: 36.7058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_588_2927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_588_2927",
    x: 87.5293,
    y: 1.88245,
    width: 39.0586,
    height: 36.7058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_588_2927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_588_2927",
    x: 1.88281,
    y: 25.4117,
    width: 116.707,
    height: 116.706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_588_2927"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_588_2927",
    result: "effect2_innerShadow_588_2927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_588_2927",
    x: 48.9414,
    y: 25.4117,
    width: 109.178,
    height: 116.706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -24,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_588_2927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_588_2927",
    x: 4.23438,
    y: 66.353,
    width: 37.6484,
    height: 37.647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_588_2927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_588_2927",
    x: 0.46875,
    y: 72,
    width: 26.3535,
    height: 26.3529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: -8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_588_2927"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_2927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160.941,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreamboto);
export default __webpack_public_path__ + "static/media/screamboto.be4f172fdf1923e3bb1802ceb7e44e39.svg";
export { ForwardRef as ReactComponent };